import { render, staticRenderFns } from "./IconSysSettings.vue?vue&type=template&id=65b6788f&"
import script from "./IconSysSettings.vue?vue&type=script&lang=js&"
export * from "./IconSysSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports